<template>
  <div>
    <input v-model.trim="search" ref="search" type="text" :placeholder="$t('stockIn.searchProductList')"
      class="form-control" />
    <div class="ts-mt-3 ts-border ts-border-gray-300 ts-p-3 ts-rounded max-h">
      <ts-loading-banner :loading="loading">
        <table class="ts-w-full">
          <thead>
            <tr>
              <th class="ts-bg-gray-200 ts-px-2 ts-py-1">
                {{ $t('stockIn.barcode') }}
              </th>
              <th class="ts-bg-gray-200 ts-px-2 ts-py-1">
                {{ $t('stockIn.productName') }}
              </th>
              <th class="ts-bg-gray-200 ts-px-2 ts-py-1 ts-text-center">
                {{ $t('stockIn.qty') }}
              </th>
              <th class="ts-bg-gray-200 ts-px-2 ts-py-1 ts-text-center">
                {{ $t('purchaseOrder.cost') }}
              </th>
              <th class="ts-bg-gray-200 ts-px-1 ts-py-1 ts-text-center"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(pro, index) in this.getProduct({
              chosenProduct: model.product_detail,
              search: search
            })" :key="index" class="ts-cursor-pointer hover:ts-bg-gray-300">
              <td @click="addItem(pro)" class="ts-whitespace-no-wrap ts-py-1">
                {{ pro.barcode }}
              </td>
              <td @click="addItem(pro)" class="ts-py-1">
                {{ pro.product_name_en }}
              </td>
              <td class="ts-whitespace-no-wrap">
                <input type="number" class="form-control" v-model.number="pro.qty" @keypress.enter="addItem(pro)" />
              </td>
              <td class="ts-pl-2 ts-whitespace-no-wrap">
                <ts-currency-input v-model.number="pro.cost" class="form-control ts-text-right" style="min-width: 100px"
                  :currency="default_currency_sign" :precision="default_precision" @keyPressEnter="addItem(pro)" />
              </td>
              <td class="ts-px-3 ts-whitespace-no-wrap">
                <a href="#" class="ts-text-blue-500" @click.prevent="addItem(pro)">
                  <i class="fa fa-plus"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </ts-loading-banner>
    </div>
    <small><i>{{ $t('stockIn.clickToAddProduct') }}</i></small>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { debounce } from 'lodash'
export default {
  name: 'modalSearchToAddProduct',
  props: ['value'],
  data() {
    return {
      model: {},
      loading: false,
      search: ''
    }
  },
  computed: {
    ...mapGetters('stock/stockIn', [
      'getProduct',
      'isDefaultUom',
      'getCostPrice'
    ]),
    default_currency_sign() {
      return this.$store.state.authUser.sys_setting.default_currency_sign
    },
    default_precision() {
      return this.$store.state.authUser.sys_setting.decimal_digit
    }
  },
  created() {
    this.model = this.value
    this.$nextTick(() => {
      this.$refs.search.focus()
    })
  },
  methods: {
    addItem(product) {
      // var uom_id = this.isDefaultUom(product.product_id)
      let newRow = {
        product_id: product.product_id,
        uom_id: product.uom_id,
        qty: product.qty ? product.qty : 1,
        // cost: this.getCostPrice({
        //   product_id: product.product_id,
        //   uom_id: uom_id
        // }),
        cost: _.round(product.cost, this.default_precision),
        discount_rate: 0,
        discount_type: '%',
        total_after_discount: null,
        vat_rate: 0,
        vat_amount: 0,
        grand_total: 0,
        expiry_date: null,
        is_expire: false,
        product_grade: '',
        imei_list: []
      }

      this.model.product_detail.push(_.clone(newRow))
      this.$nextTick(() => {
        this.$refs.search.focus()
        this.$refs.search.select()
      })
    }
  }
}
</script>

<style scoped>
.max-h {
  min-height: 50vh;
  max-height: 60vh;
  overflow: scroll;
}
</style>
